import http from '@/services/http';

const countries = {
  index(config = {}) {
    return http.request({
      method: 'get',
      url: '/countries',
      ...config,
    });
  },
};

export default countries;
